import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useContext, useEffect, useState } from 'react';
import I18nContext from './context';
export default function useI18n() {
  var i18n = useContext(I18nContext);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      setForceUpdate = _useState2[1];

  useEffect(function () {
    i18n.listen(setForceUpdate);
    return function () {
      i18n.unlisten(setForceUpdate);
    };
  }, []);
  return {
    t: i18n.t,
    i18n: i18n
  };
}